module.exports = {
  // 需要统计数据的路由列表
  routeList: [
    {
      name: '一机一拍商详页',
      route: '/new-goods-detail', // 页面路由
      pageId: 'T2974', // pageId从zeye上拷贝
      level: 10 // 页面级别
    }
  ]
}
